interface TableRowSkeletonProps {
    columns: number;
}

export function TableRowSkeleton({ columns }: TableRowSkeletonProps) {
    return (
        <tr className="animate-pulse">
            {Array.from({ length: columns }).map((_, index) => (
                <td key={index} className="px-6 py-4">
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </td>
            ))}
        </tr>
    );
}
